import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import { useT } from '../i18n/LanguageProvider';
import Brand from './Brand';
import LanguageToggle from './LanguageToggle';

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const t = useT();

  useEffect(() => setOpen(false), [location.pathname]);

  const links = [
    { to: '/tjanster', label: t.nav.services },
    { to: '/case', label: t.nav.cases },
    { to: '/insights', label: t.nav.insights },
    { to: '/om-oss', label: t.nav.about }
  ];

  return (
    <header className="nav">
      <Brand />
      <div className="nav-right">
        <nav
          className={open ? 'nav-links is-open' : 'nav-links'}
          id="nav-links"
          aria-label={t.a11y.mainMenu}
        >
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) => (isActive ? 'is-active' : undefined)}
            >
              {link.label}
            </NavLink>
          ))}
          <NavLink
            to="/kontakt"
            className={({ isActive }) => (isActive ? 'nav-cta is-active' : 'nav-cta')}
          >
            {t.nav.cta}
          </NavLink>
        </nav>
        <LanguageToggle />
        <button
          className="menu"
          type="button"
          aria-label={t.a11y.openMenu}
          aria-expanded={open}
          aria-controls="nav-links"
          onClick={() => setOpen((value) => !value)}
        >
          ☰
        </button>
      </div>
    </header>
  );
}
